import { always, ifElse, path, pathEq } from 'ramda';

export const selectValidationError = ifElse(
  pathEq(['graphQLErrors', '0', 'meta', 'name'], 'SubmissionError'),
  path(['graphQLErrors', '0', 'meta']),
  always(null)
);
